export default Object.freeze({
    Approve: 0,
    Refuse: 1,
    PublishBid: 2,
    CancelBid: 3,
    ForceStartBid: 4,
    ForceCloseBid: 5,
    PublishProgress: 6
});
